module.exports = __webpack_public_path__ + "static/professionalism_2024-33971ba666bf68c40953aee8f22e3a9c.jpg";